import { Form, Formik } from 'formik';
import { useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import { BASE_URL } from '../../constants/api-urls';
import { InputBox } from '../../components';
import { FilledButtonStyle } from '../../styles/common.style';
import { AddToPlayListModalStyle, AddToPlayListStyle } from './UsernameModelstyle';
import { toast } from 'react-toastify';

const UsernameModal = props => {
  const { username } = props;
  const [setLoading, showLoading] = useState(false);
  const [isEditModalVisible, setEditModalVisible] = useState(false);

  const handleOk = () => {
    setEditModalVisible(false);
  };

  const handleCancel = (e: any) => {
    e.stopPropagation();
    setEditModalVisible(false);
  };

  const showModal1 = () => {
    setEditModalVisible(true);
  };

  const user = JSON.parse(localStorage.getItem('userInfo'));

  const handleFormSubmit = (values: any) => {
    showLoading(true);

    axios
      .patch(`${BASE_URL}/auth0/user/${user?.userId}/profile`, { name: `${values?.username}` })
      .then(response => {
        const profile = response?.data?.data;
        let data = {
          ...user,
          profileImage: profile?.picture,
          username: profile?.name,
          email: profile?.email,
          allLogin: profile?.logins_count,
          lastLogin: profile?.last_login,
          emailVerified: profile?.email_verified,
        };
        localStorage.setItem('userInfo', JSON.stringify(data));
        toast.success('Name update successfully');
        showLoading(false);
        window.location.reload();
      })
      .catch(error => {
        console.log(error);
        toast.error('Error while updating name');
        showLoading(false);
      });
  };

  return (
    <AddToPlayListStyle>
      <span
        onClick={showModal1}
        className="editNameModal"
        style={{ top: '0px', cursor: 'pointer' }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="11" fill="#505050" stroke="white" strokeOpacity="0.2" />
          <g clipPath="url(#clip0_1895_29875)">
            <path
              d="M16.5408 9.13579L15.043 7.63801C14.9765 7.57136 14.8975 7.51847 14.8106 7.48239C14.7237 7.44631 14.6305 7.42773 14.5363 7.42773C14.4422 7.42773 14.349 7.44631 14.262 7.48239C14.1751 7.51847 14.0961 7.57136 14.0297 7.63801L7.93632 13.7669L7.44299 15.9047C7.42197 16.0083 7.42418 16.1153 7.44946 16.218C7.47474 16.3206 7.52245 16.4164 7.58918 16.4985C7.6559 16.5805 7.73998 16.6467 7.83535 16.6923C7.93073 16.738 8.03503 16.7619 8.14077 16.7625C8.19542 16.7685 8.25056 16.7685 8.30521 16.7625L10.4608 16.2869L16.5408 10.1491C16.6074 10.0826 16.6603 10.0037 16.6964 9.91674C16.7325 9.82979 16.751 9.73659 16.751 9.64245C16.751 9.54832 16.7325 9.45511 16.6964 9.36817C16.6603 9.28123 16.6074 9.20226 16.5408 9.13579ZM9.99854 15.4647L8.37188 15.8247L8.74966 14.2113L13.3363 9.59356L14.5897 10.8469L9.99854 15.4647ZM15.0919 10.3447L13.8385 9.09134L14.5274 8.38912L15.7897 9.65134L15.0919 10.3447Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1895_29875">
              <rect width="16" height="16" fill="white" transform="translate(4 4)" />
            </clipPath>
          </defs>
        </svg>
      </span>
      <AddToPlayListModalStyle
        visible={isEditModalVisible}
        onOk={handleOk}
        footer={null}
        onCancel={handleCancel}
        closable={false}
      >
        <div>
          <h1 className="heading">Edit Profile</h1>
        </div>
        <Formik
          initialValues={{
            username: username,
          }}
          onSubmit={(values, { resetForm }) => {
            handleFormSubmit(values);
            resetForm();
          }}
        >
          {() => (
            <Form className="form-wrapper">
              <InputBox
                type="text"
                name="username"
                label="Username"
                transparent={true}
                style={{ width: '100%' }}
              />
              <div className="footer">
                <FilledButtonStyle
                  background="transparent"
                  width="90px"
                  type="button"
                  onClick={handleCancel}
                  style={{}}
                  className="btn2"
                >
                  Cancel
                </FilledButtonStyle>
                <FilledButtonStyle type="submit" style={{ padding: '10px 40px', fontSize: '15px' }}>
                  {setLoading ? <LoadingOutlined /> : 'Update'}
                </FilledButtonStyle>
              </div>
            </Form>
          )}
        </Formik>
      </AddToPlayListModalStyle>
    </AddToPlayListStyle>
  );
};

export default UsernameModal;
